import React, {memo} from 'react'
import _ from 'lodash'
import {Button, Form, Grid, List, Message, Segment} from 'semantic-ui-react'
import {withErrorHandling, withHelmet, withPropsPresent, withMeData} from '../../hoc'
import {updateProfile} from '../../backend'
import {useSafeState} from '../../hook'

const _UpdateProfile = (
  {
    me,
    updateProfile,
    mutateMe
  }
) => {

  const [state, setState] = useSafeState({
    email: me.email,
    first: me.first,
    last: me.last,
    submitted: false,
    successful: false,
    errors: {}
  })

  const validate = ({first, last, errors = {}}) => {
    if (!first) {
      errors['profile.first.required'] = 'First name required'
    } else {
      delete errors['profile.first.required']
      if (first.length > 150) {
        errors['profile.first.exceeds.max.length'] = 'First name cannot exceed 150 characters'
      } else {
        delete errors['profile.first.exceeds.max.length']
      }
    }
    if (!last) {
      errors['profile.last.required'] = 'Last name required'
    } else {
      delete errors['profile.last.required']
      if (last.length > 150) {
        errors['profile.last.exceeds.max.length'] = 'LAst name cannot exceed 150 characters'
      } else {
        delete errors['profile.last.exceeds.max.length']
      }
    }
    return errors
  }

  const onInputChange = (e) => {
    let updatedState = {...state, ...{[e.target.name]: e.target.value}}
    let errors = {}
    if (state.submitted) {
      errors = validate(updatedState)
      updatedState = {...updatedState, ...{errors}}
    }
    setState(updatedState)
  }

  const submit = async (e) => {
    e.preventDefault()
    const errors = validate(state)
    if (_.keys(errors).length) {
      setState({...state, ...{errors}})
      return
    }
    let updatedState = {...state, ...{submitting: true}}
    setState(updatedState)
    await updateProfile(state)
    updatedState = {...state, ...{submitting: false, successful: true, errors: {}}}
    setState(updatedState)
    setTimeout(() => {
      setState({...updatedState, successful: false})
    }, 5000)
    mutateMe()
  }

  const {email, first, last, errors, submitting} = state
  const hasFirstError = _.keys(errors).some((k) => k.indexOf('profile.first') > -1)
  const hasLastError = _.keys(errors).some((k) => k.indexOf('profile.last') > -1)
  const hasErrors = hasFirstError || hasLastError

  return (
    <Grid divided='vertically'>
      <Grid.Row columns='16'>
        <Grid.Column width='6'>
          <Segment>
            {
              state.successful && (
                <Message success content='Profile updated successfully!'/>
              )
            }
            <Form error={hasErrors}>
              <Form.Field data-testid='profile-email-label'>
                <label>Email</label>
                <div>{email}</div>
              </Form.Field>
              <Form.Field error={hasFirstError} required data-testid='profile-first-textbox'>
                <label>First</label>
                <Form.Input placeholder='Enter first name'
                            name='first'
                            value={first}
                            onChange={onInputChange}/>
              </Form.Field>
              <Form.Field error={hasLastError} required data-testid='profile-last-textbox'>
                <label>Last</label>
                <Form.Input placeholder='Enter last name'
                            name='last'
                            value={last}
                            onChange={onInputChange}/>
              </Form.Field>
              <Message error data-testid='profile-errors'>
                <Message.Content>
                  <List bulleted>
                    {
                      _.keys(errors).map((key) => (
                        <List.Item key={key} data-test='profile-error'>{errors[key]}</List.Item>
                      ))
                    }
                  </List>
                </Message.Content>
              </Message>
              <Button primary onClick={submit} loading={submitting} data-testid='profile-submit-button'>Update Profile</Button>
            </Form>
          </Segment>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  )
}

let UpdateProfile = (props) => {
  const {handleError} = props
  props = {...props, updateProfile: handleError(updateProfile)}
  return (<_UpdateProfile {...props}/>)
}

UpdateProfile = withHelmet(UpdateProfile, 'Update Profile')
UpdateProfile = withPropsPresent(UpdateProfile, ['me'])
UpdateProfile = withMeData(UpdateProfile, 'Loading profile...')
UpdateProfile = withErrorHandling(UpdateProfile)
UpdateProfile = memo(UpdateProfile)

export {UpdateProfile}

export default UpdateProfile